<template>
  <div class="vehicle-swiper scale-animation height-100" :class="completed && 'completed'">
    <div class="board-wrapper" v-if="!completed">
      <div class="white--text mb-2 text-center size-18">
        {{cardsDone + 1}}/{{cards.length}}
      </div>
      <div ref="board" id="board" class="mx-auto">
        <template v-for="(card, i) of cards">
          <VehicleCard
            :key="card.id"
            :vehicle="card"
            class="card"
            v-if="i >= cards.length - cardsDone -2"
          >
            <template v-slot:swipeLeft>
              <div class="swipe-meta swipe-left flex-center-content col-flex">
                <img src="@/assets/img/thumbs_down.png" />
                <div class="size-24 font-weight-bold white--text mt-6">
                  Gefällt mir nicht!
                </div>
              </div>
            </template>
            <template v-slot:swipeRight>
              <div class="swipe-meta swipe-right flex-center-content col-flex">
                <img src="@/assets/img/thumbs_up.png" />
                <div class="size-24 font-weight-bold white--text mt-6">
                  Gefällt mir!
                </div>
              </div>
            </template>
          </VehicleCard>
        </template>
      </div>
    </div>
    <Results
      :rightSwiped="rightSwiped"
      :likedVehicles="likedVehicles"
      :completed="completed"
      @tryAgain="tryAgain"
    />
  </div>
</template>

<script>
import * as Hammer from 'hammerjs'
import VehicleCard from '../general/VehicleCard'
import vehicles from '@/api/vehicles.json'
import Results from '@/components/swipe/Results'
let chosenVehicles = [2, 4, 6, 13, 17, 20];

export default {
  components: {
    VehicleCard,
    Results
  },
  computed: {
    completed: function() {
      return this.cardsDone === this.cards.length;
    },
    likedVehicles: function() {
      return vehicles.filter(vehicle => this.chosenSegments.indexOf(vehicle.segment) !== -1);
    }
  },
  data: () => ({
    board: null,
    cards: [...vehicles.filter(v => chosenVehicles.indexOf(v.id) !== -1)].reverse(),
    rightSwiped: [],
    chosenSegments: [],
    topCard: null,
    nextCard: null,
    swipeRightMeta: null,
    swipeLeftMeta: null,
    hammer: null,
    cardsDone: 0
  }),
  mounted() {
    this.initSwipeFeature();
  },
  methods: {
    initSwipeFeature() {
      this.board = this.$refs.board;
      this.handle()
    },
    handle() {
      if(this.completed) return;
      
      // list all cards
      let cards = this.$refs.board.querySelectorAll('.card');
      
      // get top card
      this.topCard = cards[cards.length-1]
      this.swipeRightMeta = this.topCard.querySelector('.swipe-right');
      this.swipeLeftMeta = this.topCard.querySelector('.swipe-left');
      
      // get next card
      this.nextCard = cards[cards.length-2]

      // if at least one card is present
      if (cards.length > 0) {
        
        // set default top card position and scale
        this.topCard.style.transform =
          'translateX(-50%) translateY(0%) rotate(0deg) rotateY(0deg) scale(1)'
        
        // destroy previous Hammer instance, if present
        if (this.hammer) this.hammer.destroy()
        
        // listen for tap and pan gestures on top card
        this.hammer = new Hammer(this.topCard, {
          touchAction: 'pan-y',
          recognizers: [
              [Hammer.Pan,{ direction: Hammer.DIRECTION_HORIZONTAL }],
          ]
        })
        this.hammer.add(new Hammer.Tap())
        this.hammer.add(new Hammer.Pan({
          position: Hammer.position_ALL, threshold: 0
        }))
        
        // pass events data to custom callbacks
        this.hammer.on('tap', (e) => { this.onTap(e) })
        this.hammer.on('pan', (e) => { this.onPan(e) })
        
      }
    },
    onTap(e) {
    },
    onPan(e) {
      if(e.direction == Hammer.DIRECTION_UP) {
        this.resetCardsPosition();
        return;
      }
      if(e.direction == Hammer.DIRECTION_DOWN) {
        this.resetCardsPosition();
        return;
      }
      
      if (!this.isPanning) {
        this.isPanning = true
        
        // remove transition properties
        this.topCard.style.transition = null
        if (this.nextCard) this.nextCard.style.transition = null
        
        // get top card coordinates in pixels
        let style = window.getComputedStyle(this.topCard)
        let mx = style.transform.match(/^matrix\((.+)\)$/)
        this.startPosX = mx ? parseFloat(mx[1].split(', ')[4]) : 0
        this.startPosY = mx ? parseFloat(mx[1].split(', ')[5]) : 0
        
        // get top card bounds
        let bounds = this.topCard.getBoundingClientRect()
        
        // get finger position on top card, top (1) or bottom (-1)
        this.isDraggingFrom =
          (e.center.y - bounds.top) > this.topCard.clientHeight / 2 ? -1 : 1
        
      }
      
      // calculate new coordinates
      let posX = e.deltaX + this.startPosX
      let posY = e.deltaY + this.startPosY
      
      // get ratio between swiped pixels and the axes
      let propX = e.deltaX / this.board.clientWidth
      let propY = e.deltaY / this.board.clientHeight
      
      // get swipe direction, left (-1) or right (1)
      let dirX = e.deltaX < 0 ? -1 : 1

      if(dirX === 1)
        this.swipeRightMeta.style.opacity = e.deltaX / 35;
      else
        this.swipeLeftMeta.style.opacity = (e.deltaX * (-1)) / 35;
      
      // calculate rotation, between 0 and +/- 45 deg
      let deg = this.isDraggingFrom * dirX * Math.abs(propX) * 45
      
      // calculate scale ratio, between 95 and 100 %
      let scale = (95 + (5 * Math.abs(propX))) / 100
      
      // move top card
      this.topCard.style.transform =
        'translateX(' + posX + 'px) translateY(' + posY + 'px) rotate(' + deg + 'deg) rotateY(0deg) scale(1)'
      
      // scale next card
      if (this.nextCard) this.nextCard.style.transform =
        'translateX(-50%) translateY(0%) rotate(0deg) rotateY(0deg) scale(' + scale + ')'

      if (e.isFinal) {
						
        this.isPanning = false
        
        let successful = false
        
        // set back transition properties
        this.topCard.style.transition = 'transform 200ms ease-out'
        if (this.nextCard) this.nextCard.style.transition = 'transform 100ms linear'
        
        // check threshold
        if (propX > 0.25 && e.direction == Hammer.DIRECTION_RIGHT) {
      
          successful = true
          // get right border position
          posX = this.board.clientWidth
        
        } else if (propX < -0.25 && e.direction == Hammer.DIRECTION_LEFT) {
      
          successful = true
          // get left border position
          posX = - (this.board.clientWidth + this.topCard.clientWidth)
        
        } 
        else if (propY < -0.25 && e.direction == Hammer.DIRECTION_UP) {
      
          successful = true
          // get top border position
          posY = - (this.board.clientHeight + this.topCard.clientHeight)
      
        }
        
        if (successful) {

          if(dirX === 1)
          {
            let index = this.cards.length - this.cardsDone - 1;
            this.rightSwiped.push(this.cards[index].id);
            let segment = this.cards[index].segment;
            if(this.chosenSegments.indexOf(segment) === -1)
              this.chosenSegments.push(segment);
          }

          this.cardsDone++;
    
          // throw card in the chosen direction
          this.topCard.style.transform =
            'translateX(' + posX + 'px) translateY(' + posY + 'px) rotate(' + deg + 'deg)'
        
          // wait transition end
          setTimeout(() => {
            // remove swiped card
            this.board.removeChild(this.topCard)
            this.handle();
          }, 200)
        
        } else {
      
          // reset cards position
          this.resetCardsPosition();
      
        }
    
      }
    },
    resetCardsPosition() {
      this.topCard.style.transition = 'all 0.25s';
      if(this.nextCard)
        this.nextCard.style.transition = 'all 0.25s';

      this.swipeRightMeta.style.transition = 'all 0.25s';
      this.swipeRightMeta.style.opacity = 0;
      this.swipeLeftMeta.style.transition = 'all 0.25s';
      this.swipeLeftMeta.style.opacity = 0;

      this.topCard.style.transform =
        'translateX(-50%) translateY(0%) rotate(0deg) rotateY(0deg) scale(1)'
      if (this.nextCard) this.nextCard.style.transform =
        'translateX(-50%) translateY(0%) rotate(0deg) rotateY(0deg) scale(0.95)'
    },
    tryAgain() {
      this.cardsDone = 0;
      setTimeout(() => {
        this.initSwipeFeature();
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.vehicle-swiper {
  position: relative;

  &.scale-animation {
    transform-origin: center top;
    -webkit-transform: scale3d(1, 1, 1);
    -webkit-backface-visibility: hidden;
    transform: scale3d(1, 1, 1);
    backface-visibility: hidden;
    animation-duration: .5s;
    animation-timing-function: ease;
    animation-name: scale-animation;
  }

  &.completed {
    background-size: 100% 415px;
  }

  .board-wrapper {
    padding-top: 110px;
    background: linear-gradient(33.53deg, #022239 0%, #030E30 100%);
    min-height: 90vh;
    background-size: 100% 275px;
    background-repeat: no-repeat;
    background-attachment: fixed;
  }
}
#board {
  width: 100%;
  position: relative;
  overflow: visible;
}
.card {
  width: 95%;
  // min-height: 320px;
  position: absolute;
  top: 50%;
  left: 50%;
  box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.1);
  background-color: white;
  transform: translateX(-50%) translateY(0%) scale(0.95);
  margin-bottom: 50px;
  overflow: hidden;
  // transition: transform 0.25s;

  .swipe-meta {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    opacity: 0;
    pointer-events: none;

    &.swipe-right {
      background: linear-gradient(215.21deg, #228B22 0%, #014327 100%);
    }
    &.swipe-left {
      background: linear-gradient(215.07deg, #F5542D 0%, #AD2200 100%);
    }
  }
}
@keyframes scale-animation {
  from {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0, 0, 0);
  }
  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style>